module.exports = __webpack_public_path__ + "static/media/icon_xls.152573d4.svg";